import { render, staticRenderFns } from "./TagDescription.vue?vue&type=template&id=253e0154&scoped=true&"
import script from "./TagDescription.vue?vue&type=script&lang=js&"
export * from "./TagDescription.vue?vue&type=script&lang=js&"
import style0 from "./TagDescription.vue?vue&type=style&index=0&id=253e0154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e0154",
  null
  
)

export default component.exports